import { Icon, IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { FeatureFlagName } from "~/gql/graphqlBase.generated";
import useFeatureFlag from "~/hooks/useFeatureFlag";
import runGuardedExit from "~/layout/unsavedChangesRegistry";

const INBOX_ROUTE = "/inbox";

const InboxButton = () => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();
	const { isEnabled } = useFeatureFlag(FeatureFlagName.InboundDocuments);

	if (!isEnabled) return null;

	return (
		<IconButton
			aria-label={t("inbox.buttonLabel")}
			color="inherit"
			onClick={() => runGuardedExit(() => navigate(INBOX_ROUTE))}
			size="small"
		>
			<Icon>inbox</Icon>
		</IconButton>
	);
};

export default InboxButton;
